import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.target = this.element.querySelector('.radio-target');
    }

    switch(event) {
        if (event.target.dataset.canEdit === '1') {
            this.target.value = event.target.value;
            this.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
        }
    }
}
